module.exports = __webpack_public_path__ + "img/undraw_logic_n6th.9b397083.svg";